// src/firebaseInf.js
import { initializeApp, getApps } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// Give it a custom name!
const firebaseConfig = {
  apiKey: "AIzaSyC_RGg6U7fA8p8Y9dzk3EiVLmrm1Lmf4ZQ",
  authDomain: "styleuaiinfluencers.firebaseapp.com",
  projectId: "styleuaiinfluencers",
  storageBucket: "styleuaiinfluencers.firebasestorage.app", // ✅
  messagingSenderId: "473568929131",
  appId: "1:473568929131:web:439d46a5032912ed42d82e",
  measurementId: "G-LQJWGFK8C3"
};

// ✅ Give it a unique name like "influencer"
const app =
  getApps().find(app => app.name === "influencer") ||
  initializeApp(firebaseConfig, "influencer");

const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

export { db as infDb, storage as infStorage, auth as infAuth };
